import type {
  GroupProps as ReactSelectGroupProps,
  OptionTypeBase,
} from 'react-select';

import { Box, type BoxProps } from '@frontend/legacy-components';

import { useSelectStyles } from '../SelectStylesContext';
import { GroupHeading } from './GroupHeading';

export type GroupProps<
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
> = ReactSelectGroupProps<OptionType, IsMulti> & {
  innerProps?: BoxProps;
};

export const Group = <
  OptionType extends OptionTypeBase = { label: string; value: string },
  IsMulti extends boolean = false,
>({
  label,
  headingProps,
  innerProps,
  children,
}: GroupProps<OptionType, IsMulti>) => {
  const { group: groupStyles } = useSelectStyles();

  return (
    <Box __css={groupStyles} {...innerProps}>
      <GroupHeading {...headingProps}>{label}</GroupHeading>
      {children}
    </Box>
  );
};
